module.exports = __webpack_public_path__ + "94ccefa1ff50225a13a5ddc0aaef510a.png";